import React, { Component } from 'react';
import { connect } from 'react-redux';
import inViewport from 'in-viewport';
import Link from './Link';
import { getSlug } from '../utils/url';
import { removeLeadingSlash, addTrailingSlash } from '../utils/string';
import { showDocument, documentInView } from '../actions/document';

class PublicationTitle extends Component {
  componentWillUpdate(props) {
    const {
      psiEnabled,
      checkedEntitlement,
    } = props;

    if (psiEnabled && checkedEntitlement && !this.onReadyStateChangedAttached) {
      if (document.readyState === 'complete') {
        this.observe();
        return;
      }

      document.addEventListener('readystatechange', this.onReadyStateChanged);
      this.onReadyStateChangedAttached = true;
    }
  }

  componentWillUnmount() {
    if (this.props.psiEnabled) {
      document.removeEventListener('readystatechange', this.onReadyStateChanged);
    }
  }

  onReadyStateChanged = (ev) => {
    if (ev.target.readyState === 'complete') {
      this.observe();
    }
  }

  observe = () => {
    const { id } = this.props.doc;
    inViewport(this.element, () => this.props.documentInView({ id }));
  }

  render() {
    const {
      doc,
      track,
      query,
      currentPage,
      position,
      isSuggested,
      isEntitled,
      psiEnabled,
      baseURL,
    } = this.props;

    const trackDetails = track ? { ...track, action: 'Open', value: { documentId: doc.id } } : {};
    // link to weblet-article on staging
    const isStaging = baseURL.includes('staging');
    const articleURL = isStaging ?
      `${baseURL}${addTrailingSlash(removeLeadingSlash(getSlug(doc.link)))}` :
      getSlug(doc.link);
    return (
      <h3
        ref={(e) => { this.element = e; }}
        data-name="title"
        title={doc.title}
        onClick={() => this.props.showDocument({
          doc,
          query,
          position,
          currentPage,
          isSuggested,
        })}
      >
        <Link
          external={isStaging}
          to={articleURL}
          track={trackDetails}
        >
          <span className="label">
            {doc.title}
          </span>
          {psiEnabled && doc.hasPdf && isEntitled && (
            <i className="flag">PDF</i>
          )}
        </Link>
      </h3>
    );
  }
}

const mapStateToProps = (state, props) => ({
  baseURL: state.location.baseURL,
  isEntitled: state.entitlements[props.doc.id],
  checkedEntitlement: typeof state.entitlements[props.doc.id] !== 'undefined',
  psiEnabled: state.config.features.psiEnabled,
});

const mapDispatchToProps = {
  showDocument,
  documentInView,
};

export default connect(mapStateToProps, mapDispatchToProps)(PublicationTitle);



// WEBPACK FOOTER //
// ./src/universal/ui/components/PublicationTitleContainer.js